import { Intervention, Recommendation, Sample, Scouting } from '@agroone/entities'
import { Pipe, PipeTransform } from '@angular/core'
import { dateOf } from '../utils/date-of.util'

type ItemUser = string | number | null | undefined

@Pipe({
  name: 'itemsByUser',
})
export class ItemsByUserPipe implements PipeTransform {
  transform(items: (Scouting | Recommendation | Intervention | Sample)[]): {
    user: ItemUser
    items: (Scouting | Recommendation | Intervention | Sample)[]
  }[] {
    return items
      .sort((x, y) => dateOf(y.date).getTime() - dateOf(x.date).getTime())
      .reduce(
        (
          result: { user: ItemUser; items: (Scouting | Recommendation | Intervention | Sample)[] }[],
          item: Scouting | Recommendation | Intervention | Sample,
        ) => {
          const itemUser = this.getUser(item)
          const foundItem = result.find((i) => i.user === itemUser)

          if (!foundItem) {
            result.push({
              user: itemUser,
              items: [item],
            })
          } else {
            // Check if there's already the user
            foundItem.items.push(item)
          }
          return result
        },
        [],
      )
  }

  private getUser(i: Scouting | Recommendation | Intervention | Sample): ItemUser {
    if ((i as Scouting)?.scoutedBy) {
      return (i as Scouting).scoutedByName
    } else if ((i as Recommendation)?.recommendedBy) {
      return (i as Recommendation).recommendedBy
    } else if ((i as Intervention)?.completedBy) {
      return (i as Intervention).completedBy
    } else {
      return (i as Sample).createdBy
    }
  }
}
